module.exports = __webpack_public_path__ + "7a8636aebc42e4b478aab2fb46f590c9.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_r_30.mp3
// module id = 416
// module chunks = 0